export default __webpack_public_path__ + "static/media/eye (1).0f4b62c2.svg";